module.exports = __webpack_public_path__ + "img/partner-stauder.0ff0c149.png";